export default "__VITE_ASSET__a05ccb54__"